import { Component } from '@angular/core';

import { SitecoreMyBetsConfig } from '@frontend/sports/common/client-config-data-access';

import { MyBetsEditBetHistoryService } from '../../services/my-bets-edit-bet-history.service';

@Component({
    selector: 'ms-my-bets-edit-bet-history-header',
    templateUrl: './my-bets-edit-bet-history-header.html',
})
export class MyBetsEditBetHistoryHeaderComponent {
    constructor(
        public sitecoreMyBets: SitecoreMyBetsConfig,
        private editBetHistoryService: MyBetsEditBetHistoryService,
    ) {}

    backToList(): void {
        this.editBetHistoryService.resetEditBetHistory();
    }
}
